(ns common.schema.entities.named-value
  (:require
    [common.schema.schema-utils :as su]))

(def schema
  (concat
    [[:named-value/attribute
      {:field/data-type             :data.type/keyword
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/none
                                     :filter           :filter.type/none
                                     :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/none
                                     :access/write :role/user}}]

     [:named-value/value
      {:field/data-type             :data.type/text-simple
       :field/default-visibility    {:editor           :editor.type/text-simple
                                     :grid             :editor.type/text-simple
                                     :filter           :filter.type/text
                                     :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/user}
       :field/lower-case-str?       true
       :field/constraints           {:constraint/string-min-length 1}
       :field/translations          {:en "Value"}
       }]]
    (su/multi-ref-field :named-value/archived-in-pipelines
                        "Archived in pipelines"
                        [:entity.type/pipeline]
                        {:authorization            su/access-admin-ssg
                         :default-field-visibility :in-use-disabled})))
